import { AnimatedImageDto } from "@repo/api/animated-image";
import { CompositionDto } from "@repo/api/editor";
import {
  getAnimatedImageSrcs,
  prefetchVideos,
} from "@repo/video-engine-i2v/utils/preload";
import { useEffect } from "react";

export function usePreloadAnimatedImages({
  composition,
  animatedImages,
  isPlaying,
}: {
  composition: CompositionDto;
  animatedImages: Record<string, AnimatedImageDto>;
  isPlaying: boolean;
}) {
  // A string instead of an array so composition edits that don't change the
  // srcs keep the effect from re-running and aborting the in-flight download.
  const srcsKey = getAnimatedImageSrcs({ composition, animatedImages }).join(
    "\n",
  );

  useEffect(() => {
    if (isPlaying || !srcsKey) {
      return;
    }

    const controller = new AbortController();
    void prefetchVideos({
      srcs: srcsKey.split("\n"),
      signal: controller.signal,
    });

    return () => controller.abort();
  }, [srcsKey, isPlaying]);
}
